var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.039,
    height: 249.031,
    viewBox: "0 0 222.039 249.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(2.999 2.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M94.775,9.82A80.839,80.839,0,1,1,3.966,142.935",
    transform: "translate(80.377 82.068)",
    fill: "none",
    stroke: "#f5f8fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M11,195.624H26.494a13.473,13.473,0,0,0,13.473-11.317l9.7-58.2a13.473,13.473,0,0,1,13.473-11.317h55.644a13.473,13.473,0,0,0,13.473-13.473V7",
    transform: "translate(-10.999 46.893)",
    fill: "none",
    stroke: "#f5f8fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M35.946,29.946A26.946,26.946,0,1,0,62.893,3,26.946,26.946,0,0,0,35.946,29.946Zm26.946,80.839H9",
    transform: "translate(58.367 -2.999)",
    fill: "none",
    stroke: "#f5f8fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.42f9799df8f0373721965e142430c299.svg";
export { ForwardRef as ReactComponent };